<!--  -->
<template>
  <div>
    <div id="cont">
      <div class="cont">
        <div class="cont_l">
          <div class="cont_l_01">
            <div class="cont_l_02">
              <img :src="images.sb_03">
            </div>
            <div class="cont_l_03">
              <ul class="lit01">
                <li class="lit01_c">
                  <p class="littitle">{{text.device01}}</p>
                  <ul class="lit02">
                    <li class="lit02_a">
                      <router-link to="/devicezh/lglzzh">{{text.device02}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/devicezh/ggsczh">{{text.device03}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/devicezh/gjsczh">{{text.device04}}</router-link>
                    </li>
                  </ul>

                  <p class="littitle">{{text.device05}}</p>

                  <ul class="lit02">
                    <li class="lit02_a">
                      <router-link to="/devicezh/gsplzh">{{text.device06}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/devicezh/spfrzh">{{text.device07}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/devicezh/xxzjzh">{{text.device08}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/devicezh/dkzjzh">{{text.device09}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/devicezh/lhlbzh">{{text.device10}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/devicezh/jyjjzh">{{text.device11}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/devicezh/zsthzh">{{text.device12}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/devicezh/lxthzh">{{text.device13}}</router-link>
                    </li>
                  </ul>

                  <p class="littitle">{{text.device14}}</p>

                  <ul class="lit02">
                    <li class="lit02_a">
                      <router-link to="/devicezh/jcjzh">{{text.device15}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/devicezh/jcmjzh">{{text.device16}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/devicezh/zsmjzh">{{text.device17}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/devicezh/jtlgzh">{{text.device18}}</router-link>
                    </li>
                  </ul>

                  <p class="littitle">{{text.device19}}</p>
                  <ul class="lit02">
                    <li class="lit02_a">
                      <router-link to="/devicezh/dkzgzh">{{text.device20}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/devicezh/lxgpzh">{{text.device21}}</router-link>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            <div class="cont_l_04"></div>
          </div>
        </div>
        <div class="cont_r">
          <div class="cont_r_t">
            <div class="cont_r_t01">
              <span>{{text.profile3}}</span>
              <span>：</span>
              <span>{{text.profile4}}</span>
              <span>-</span>
              <span>{{text.device22}}</span>
            </div>
          </div>
          <div class="cont_r_b">
            <div id="rightdiv">
              <router-view></router-view>
            </div>
            <div class="cont_r_b10">
              <router-link to="/bbszh" target="_blank">
                <img :src="images.scy_03">
              </router-link>
            </div>
            <div class="clear"></div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        scy_03: require("../../../assets/img/zh/scy_03.jpg"),
        sb_03: require("../../../assets/img/zh/sb_03.jpg")
      },
      text: {
        profile3: "您当前所在位置",
        profile4: "首页",
        device01: "成套设备",
        device02: "铝杆连铸连轧生产线",
        device03: "铜管生产线",
        device04: "钢筋生产线",
        device05: "有色金属加工设备",
        device06: "高速盘拉机组",
        device07: "水平复绕机组",
        device08: "行星轧机",
        device09: "多辊轧机",
        device10: "联合拉拔精整机组",
        device11: "挤压机机组",
        device12: "罩式退火炉",
        device13: "连续退火炉",
        device14: "挤塑注塑模具",
        device15: "挤出机",
        device16: "挤出模具",
        device17: "注塑模具",
        device18: "机筒螺杆",
        device19: "黑色金属加工设备",
        device20: "多辊轧钢机",
        device21: "连续钢坯铸造机组",
        device22: "设备及技术解决方案"
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/zh/device/device.vue